var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailbox = function SvgMailbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 241 240"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mailbox_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#mailbox_svg__b)",
    d: "M240.744 120a119.35 119.35 0 0 1-30.65 80.013c-.11.129-.229.258-.348.377-.12.119-.348.387-.537.576a120.2 120.2 0 0 1-40.245 28.851 120.4 120.4 0 0 1-96.975 0 120.2 120.2 0 0 1-40.245-28.851l-.418-.457-.437-.476a119.9 119.9 0 0 1-27.027-50.796 119.8 119.8 0 0 1-.238-57.513A119.9 119.9 0 0 1 30.23 40.706 120.25 120.25 0 0 1 77.564 7.902 120.5 120.5 0 0 1 134.758.848a120.4 120.4 0 0 1 53.915 20.314 120.1 120.1 0 0 1 38.25 43.018 119.8 119.8 0 0 1 13.801 55.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    d: "M209.219 200.966a120.2 120.2 0 0 1-40.245 28.851 120.39 120.39 0 0 1-96.975 0 120.2 120.2 0 0 1-40.245-28.851 120.2 120.2 0 0 1 40.245-28.851 120.4 120.4 0 0 1 96.975 0 120.2 120.2 0 0 1 40.245 28.851M101.049 55.688c-13.058-2.233-24.156 10.331-24.375 23.551l2.387 38.329 30.471 8.565 7.081-44.83c1.601-11.76-3.978-23.64-15.564-25.615"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    d: "M109.522 126.124c-.706.357-23.53 11.81-33.812 14.728-13.714 3.88-42.106 5.558-44.831-3.593l-.21-2.759c3.62 6.431 13.556 6.759 20.994 7.186-3.739-.219-17.602-1.519-20.406-8.724-1.93-4.963 5.062-10.54 16.25-12.218 9.218-1.379 27.845-2.729 27.845-2.729l15.404 2.59-11.705-3.037 22.873 4.079zM149.013 56.462c-11.536-.189-9.269 12.277-9.458 23.82l-9.686 30.091 31.117 8.734 8.573-41.446a20.82 20.82 0 0 0-5.87-14.85 20.917 20.917 0 0 0-14.676-6.35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    d: "m160.986 119.097-51.464 7.037L97.996 55.42s17.443-.328 19.959.436c2.516.765 10.552 4.467 9.706 18.242l1.104-18.053 20.248.417z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    d: "m118.83 114.929-3.381 52.482 14.271.228-2.277-51.5zM129.959 36.593l21.341 1.29-1.183 8.843-13.167-1.092-1.402 38.835-8.583.913z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mailbox_svg__b",
    x1: 120.501,
    x2: 120.501,
    y1: 240,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8619"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBA17"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mailbox_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.259 0h240.485v240H.259z"
  })))));
};
export default SvgMailbox;